/* tslint:disable */
// (AUTO-GENERATED PAGE BUNDLE)
// PAGE NAME: comments-pinboard-page
// ==============================
import 'entry/base'
import * as commandQueue from 'init/command-queue'
import globalStore from 'init/global-store'
import { checkTurntoflow } from 'email-flows/email-flow-entry'
import { loadConfig as loadGlobalConfig } from 'init/global.config'
import { loadIcons } from 'init/resource-loader'
import { loadMessages } from 'services/msg'
import * as commentsPinboardLoader from 'widgets/comments-pinboard/comments-pinboard-loader'
import { loadLoggedInUser } from 'services/token-service'

function loadConfig(config) {
  loadIcons(require.context('build/v6J5ZUpvDmQ7AMLsite/assets/svg/comments-pinboard-page', true, /.svg$/))
  loadMessages(config.messages, config.pluralRuleFn)
  loadGlobalConfig(config.globalConfig)
  Promise.all([
    commentsPinboardLoader.loadWidget(config.commentsPinboard)
  ]).then(() => {
    globalStore.loaders = [
      commentsPinboardLoader
    ]
    commandQueue.init()
  })
  loadLoggedInUser()
  checkTurntoflow()
}

export { loadConfig }



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/build/v6J5ZUpvDmQ7AMLsite/entry/comments-pinboard-page.ts